export default class EvaluationCategoryDto {
  categoryId;
  listId;
  categoryName;
  abolitionFlg;

  constructor(data) {
    this.categoryId = data.categoryId;
    this.listId = data.listId;
    this.categoryName = data.categoryName;
    this.abolitionFlg = data.abolition;
  }
}
